// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/address-book2/address-book.component.css
// module id = 493
// module chunks = 0